import * as yup from 'yup';

export const createSchema = yup.object().shape({

    label: yup.string().required(),

    value: yup.string().required()

});